import React, { Component } from "react";
import { Row, Col, Space, Image } from "antd";
import { Link } from "react-router-dom";
import "../../App.css";

export default class Afters extends Component {
  render() {
    return (
      <>
        <Row>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row justify="center">
              <Col span={24} className="paddLR10">
                <Link className="breadCrumbText link" to="/home">
                  Home
                </Link>
                &nbsp;&gt;&nbsp;
                <Link className="breadCrumbText link" to="/Illustration">
                  Illustration
                </Link>
              </Col>
              <Col span={24} className="f4EM color110 paddLR10 paddTop60 fAN">
                Afters Store
              </Col>
              <Col span={24} className="paddTop60"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row className="bgColorGray" justify="center">
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row>
              <Col span={24} className="paddTop40 paddLR10">
                <Space size="large" direction="vertical">
                  <div className="color110 f2EM fAN paddLR10 paddTop20">
                    Day & Night
                  </div>
                  <Image
                    alt="Station 0 Image"
                    className="img100"
                    src={`${process.env.PUBLIC_URL}/images/jpg/Station.jpg`}
                    loading="lazy"
                    preview={false}
                    placeholder={
                      <Image
                        src={`${process.env.PUBLIC_URL}/images/jpg/Station_blur.jpg`}
                        preview={false}
                        className="img100"
                      />
                    }
                  />
                  <Image
                    alt="Station 1 Image"
                    className="img100"
                    src={`${process.env.PUBLIC_URL}/images/jpg/Station_1.jpg`}
                    loading="lazy"
                    preview={false}
                    placeholder={
                      <Image
                        src={`${process.env.PUBLIC_URL}/images/jpg/Station_1_blur.jpg`}
                        preview={false}
                        className="img100"
                      />
                    }
                  />
                  <div className="f2EM color110 fAN paddTop40 colCenter">
                    Layout
                  </div>
                  <div className="paddTop10"></div>
                  <Image
                    alt="Station 2 Image"
                    className="img100"
                    loading="lazy"
                    src={`${process.env.PUBLIC_URL}/images/jpg/Station_2.jpg`}
                    preview={false}
                    placeholder={
                      <Image
                        src={`${process.env.PUBLIC_URL}/images/jpg/Station_2_blur.jpg`}
                        preview={false}
                        className="img100"
                      />
                    }
                  />
                </Space>
              </Col>
              <Col span={24} className="paddTop40"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row>
          <Col>
            <div className="rH100"></div>
          </Col>
        </Row>
      </>
    );
  }
}
